import script from "./baseInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./baseInfo.vue?vue&type=script&setup=true&lang=js"

import "./baseInfo.vue?vue&type=style&index=0&id=8729a00e&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8729a00e"]])

export default __exports__